export const css = (klasses) => {
  return klasses;
};

export const routes = [
  "Asiakasrekisteri",
  "Tilausrekisteri",
  "Hintaluokat",
  "ALV ja lisät",
  "Myyntiraportti",
];
